






































import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import EventBus from "@/utils/eventBus";
import SuperPayAndBackUpHelpers, {
  TEMP_KEY,
  LOCAL_KEY
} from "@/utils/superPayAndBackUp";
import BakcPress, { SUPER_PAY_LAUNCH_RETAIN_DIALOG } from "@/utils/backPress";
import { sendEvent, sendEventWithParams } from "@/utils/analytics";

@Component({
  components: {
    // [Tabbar.name]: Tabbar,
  }
})
export default class SuperPayLaunchToast extends Vue {
  @Getter(types.GETTER_SUPER_PAY_APP_CONFIG)
  private superPayAppConfig: any;
  @Getter(types.GETTER_SUPER_PAY_PARAMS)
  private superPayAppParams: any;
  @Getter(types.GETTER_SUPER_PAY_SHOW_ENABLE)
  private superPayShowEnable: any;
  @Action(types.START_INSTALL_SUPER_PAY_APP)
  private startInstallSuperPayApp: any;
  @Action(types.SHOW_FREE_FOLLOWERS)
  private showFreeFollowers: any;
  @Getter(types.GETTER_SUPER_PAY_APP_DESC)
  private superPayAppDesc: any;

  private superPayDialogShow: boolean = false;
  private closeFn: any = () => {};

  get iconUrl() {
    return this.superPayAppConfig.iconUrl;
  }

  get reward() {
    return this.superPayAppConfig.reward;
  }

  get title() {
    return (
      this.superPayAppParams.description &&
      this.superPayAppParams.description.title
    );
  }

  get content() {
    return this.superPayAppDesc();
  }

  get superPayShow() {
    return this.superPayShowEnable;
  }

  private closeToast() {
    this.superPayDialogShow = false;
    this.continusLogic();
  }

  private clickClose() {
    this.closeFn ? this.closeFn() : void 0;
    this.closeToast();
    BakcPress.destroy(SUPER_PAY_LAUNCH_RETAIN_DIALOG);
  }

  private clickMask() {
    this.clickClose();
  }

  private continusLogic() {
    this.showFreeFollowers();
  }

  private clickRecommend() {
    this.startInstallSuperPayApp({
      ga: "launch_popup_small"
    });
    this.closeToast();
  }

  private created() {}

  private mounted() {
    EventBus.$on("show-super-pay-launch-toast", (val: any) => {
      if (val.show) {
        this.superPayDialogShow = true;

        BakcPress.listen({
          key: SUPER_PAY_LAUNCH_RETAIN_DIALOG,
          fn: () => {
            this.clickClose();
          }
        });

        sendEventWithParams("uia_recommend_app_show", {
          super_pay: "launch_popup_small"
        });
      } else {
        this.superPayDialogShow = false;
      }

      if (val.closeFn) {
        this.closeFn = val.closeFn;
      }
    });
  }
}
